<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <div>
    <b-modal
      ref="first_transition"
      class="mod"
      size="xl"
      hide-footer
      header-bg-variant="light"
      body-bg-variant="light"
      no-close-on-backdrop
      no-close-on-esc
    >
      <template v-slot:modal-header>
        <h3>
          Bravo, tu as terminé le première épreuve !
        </h3>
      </template>
      <div class="">
        <img
          src="https://cdn.exploreve.fr/content/IM3/images/jeu_ballon/interfaces/transiton_niv1_niv2.svg"
          class="w-100 h-auto"
        />

        <p>
          <span class="font-weight-bold">Félicitations, c’était un magnifique premier vol !</span> Tu commences à avoir
          le coup de main ! Mais ton apprentissage n’est pas fini pour autant. Avant d’aller explorer un nouvel endroit,
          je vais t’enseigner comment tu repérer dans un environnement.
        </p>
        <br />
        <button type="submit" class="mx-auto validate" @click="transitionFinished(1)">
          Commencer les explications
        </button>
      </div>
    </b-modal>
    <b-modal
      ref="second_transition"
      class="mod"
      size="xl"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      header-bg-variant="light"
      body-bg-variant="light"
    >
      <template v-slot:modal-header>
        <h3>
          Bravo ! C'était un magnifique second vol.
        </h3>
      </template>
      <div>
        <div class="picture">
          <div class="img2">
            <div class="bulle2">
              <div class="cadre2">
                <p>
                  Tu sens cette brise ? C'est un vent favorable qui nous pousse dans la bonne direction. J'ai
                  l'impression qu'il va être stable pendant un bon moment, on peut en profiter pour se reposer un peu.
                  Ces périodes-là, où l’on n'a pas besoin de manœuvrer le ballon-songe, c’est l’occasion rêvée pour
                  discuter ! Et si on écrivait un message à une autre personne dans son ballon ? Ensuite on le donnera à
                  un oiseau-songe qui le transmettra au premier ballon qu’il croisera !
                </p>
              </div>
            </div>
            <div class="bs-transition2">
              <img src="https://cdn.exploreve.fr/content/ballons/ballon_rouge.svg" alt="" />
            </div>
          </div>
        </div>
        <button type="submit" class="mx-auto validate" @click="transitionFinished(2)">Écrire un message</button>
      </div>
    </b-modal>
    <b-modal
      ref="third_transition"
      class="mod"
      size="xl"
      hide-footer
      header-bg-variant="light"
      body-bg-variant="light"
      no-close-on-backdrop
      no-close-on-esc
    >
      <template v-slot:modal-header>
        <h3>
          Ça y est, ton entraînement est terminé !
        </h3>
      </template>
      <div class="bod">
        <div class="picture">
          <div class="img">
            <div class="bulle">
              <div class="cadre">
                <p>
                  Félicitations, le ballon-songe et sa maniabilité n’ont plus de secrets pour toi ! C’était vraiment un
                  beau moment, de vous voir tous et toutes apprendre en même temps, aux quatre coins de la Troposphère.
                  J’ai vu que vous aviez pu échanger quelques mots aussi entre vous, on peut dire merci aux Oiseaux pour
                  ça, ils sont étranges mais très sympas, en fait !
                </p>
              </div>
            </div>
            <div class="leon">
              <img src="https://cdn.exploreve.fr/content/personnages/leon.svg" alt="" />
            </div>
          </div>
        </div>
        <NextButton url="/immersion03/4" text="Descendre du ballon" class="mx-auto" />
      </div>
    </b-modal>
  </div>
</template>
<script>
import NextButton from "@/components/NextButton";
import { mapGetters } from "vuex";
export default {
  components: { NextButton },
  methods: {
    transitionFinished(id) {
      switch (id) {
        case 1:
          this.$refs.first_transition.hide();
          this.$store.dispatch("changeState", "LECTURE");
          break;
        case 2:
          this.$refs.second_transition.hide();
          this.$store.dispatch("changeState", "MESSAGE_WRITE");
          break;
      }
    }
  },
  computed: {
    ...mapGetters(["game_state"], "game_state"),
    ...mapGetters(["current_stage"], "current_stage"),
    ...mapGetters(["is_end"], "is_end")
  },
  watch: {
    game_state: function (value) {
      if (value === "FINISHED") {
        switch (this.current_stage) {
          case 1:
            this.$refs.first_transition.show();
            break;
          case 2:
            if (!this.is_end) {
              this.$refs.second_transition.show();
            }
            break;
        }
      }
      if (value === "MESSAGE_READ") {
        this.$refs.third_transition.show();
      }
    }
  }
};
</script>
<style scoped lang="scss">
.img {
  position: absolute;
  top: 10%;
  left: 15%;
  z-index: 10;
}

.bulle {
  position: absolute;
  top: 20px;
  left: -8vw;
  z-index: 10;
}

.cadre {
  position: absolute;
  background-color: white;
  width: 540px;
  border-radius: 20px;
  text-align: left;
  padding: 20px;
  z-index: 10;
}

.cadre::after {
  content: "";
  position: absolute;
  left: 100%;
  top: 15%;
  width: 0;
  height: 0;
  border-top: 20px solid transparent;
  border-bottom: 20px solid transparent;
  border-left: 60px solid white;
}

.leon {
  position: absolute;
  top: 10%;
  left: 40vw;
  img {
    height: 50vh;
  }
  z-index: 5;
}

.support {
  position: absolute;
  background-color: $light;
  left: 530px;
  top: 70vh;
  height: 15vh;
  width: 38vh;
  -webkit-border-radius: 19vh / 8vh;
  -moz-border-radius: 19vh / 8vh;
  border-radius: 19vh / 8vh;
}
.close {
  display: none;
}
.validate {
  background: #5e2a57;
  border-radius: 5px;
  font-family: Faune;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 36px;
  display: flex;
  align-items: center;
  text-align: center;
  padding: 12px 24px;
  color: #ffffff;
  text-align: center;
}

p {
  font-family: Faune;
  font-style: normal;
  font-weight: normal;
}
h3 {
  font-family: Faune;
}
.bs-transition2 {
  position: absolute;
  right: -12vw;
  img {
    height: 60vh;
  }
  z-index: 5;
}

.img2 {
  position: absolute;
  top: 5%;
  left: 15%;
  z-index: 10;
}

.bulle2 {
  position: absolute;
  top: 23vh;
  left: 13vw;
  z-index: 10;
}

.cadre2 {
  position: absolute;
  background-color: white;
  width: 480px;
  border-radius: 20px;
  text-align: left;
  padding: 20px;
  z-index: 10;
}

.cadre2::after {
  content: "";
  position: absolute;
  right: 100%;
  bottom: 15%;
  width: 0;
  height: 0;
  border-top: 20px solid transparent;
  border-bottom: 20px solid transparent;
  border-right: 60px solid white;
}
.picture {
  height: 60vh;
}
</style>
